import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import * as styles from './App.scss';
import AppErrorPage from '../ErrorPage';
import Rating from '../Rating';
import Breadcrumbs from '../Breadcrumbs';
import AppLoadingPage from '../AppLoadingPage';
import strings from '../../strings';
import Notifications from '../Notifications';
import AppLoadingPageMobile from '../AppLoadingPageMobile';

const App = ({
  showErrorPage, errorPageModel, showLoadingPage, isMobile,
}) => {
  if (showErrorPage) {
    return <AppErrorPage {...errorPageModel} />;
  }

  if (showLoadingPage) {
    return isMobile ? <AppLoadingPageMobile /> : <AppLoadingPage />;
  }

  return (
    <Fragment>
      <Notifications />
      <Helmet>
        <title>{strings.seoTitle}</title>
        <meta name="description" content={strings.seoDescription} />
      </Helmet>
      <div className={styles.layout}>
        <div className={styles.contentContainer}>
          {!isMobile && <Breadcrumbs />}
          <Rating />
        </div>
      </div>
    </Fragment>
  );
};

export default App;
